import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AccessMark from './AccessMark';
import Typography from '@material-ui/core/Typography';
import { makeTransformStyles } from '../../core/styles';
import {
  ACCESS_GRID_BREAKPOINT,
  ACCESS_MARK_MAX_WIDTH,
  ACCESS_MARK_POINT_SIZE,
} from './variables';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  container: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    margin: 'auto',
    position: 'relative',
    zIndex: 10,
    [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
    },
  },
  item: {
    '&:nth-of-type(even)': {
      margin: theme.spacing(
        2,
        'auto',
        2,
        `${ACCESS_MARK_POINT_SIZE + theme.spacing(1)}px`,
      ),
      [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
        width: '100%',
        margin: theme.spacing('auto', 'auto', 0),
      },
    },
    '&:nth-of-type(odd)': {
      [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
        minWidth: ACCESS_MARK_MAX_WIDTH - 10,
      },
      [theme.breakpoints.up('lg')]: {
        minWidth: ACCESS_MARK_MAX_WIDTH,
      },
    },
  },
  typography: {
    fontSize: theme.typography.pxToRem(14),
    textAlign: 'left',
    [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
      whiteSpace: 'pre-wrap',
      textAlign: 'center',
    },
    [theme.breakpoints.only(ACCESS_GRID_BREAKPOINT)]: {
      fontSize: '1.1vw',
    },
  },
  horizontalLine: {
    width: '100%',
    borderBottom: `4px dashed ${theme.palette.primary.main}`,
    position: 'absolute',
    zIndex: 5,
    top: '50%',
    ...makeTransformStyles('translateY(-50%)'),
    display: 'none',
    [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
      display: 'block',
    },
  },
  verticalLine: {
    height: '100%',
    position: 'absolute',
    zIndex: 5,
    borderLeft: `3px dashed ${theme.palette.primary.main}`,
    left: (ACCESS_MARK_POINT_SIZE - 3) / 2,
    top: 0,
    [theme.breakpoints.up(ACCESS_GRID_BREAKPOINT)]: {
      display: 'none',
    },
  },
}));

const AccessGrid = ({ directions = [] }) => {
  const classes = useStyles({ directions });
  return (
    <div className={classes.root}>
      <div className={classes.horizontalLine} />
      <div className={classes.verticalLine} />
      <div className={classes.container}>
        {directions.map((direction, index) => {
          if (index % 2 === 0) {
            return (
              <div key={`grid-${index}`} className={classes.item}>
                <AccessMark>
                  {Array.isArray(direction) ? (
                    direction
                  ) : (
                    <span>{direction}</span>
                  )}
                </AccessMark>
              </div>
            );
          } else {
            return (
              <div key={`grid-${index}`} className={classes.item}>
                <Typography
                  color="textPrimary"
                  align="center"
                  className={classes.typography}
                >
                  {direction}
                </Typography>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default AccessGrid;
